import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  activityItem: {
    minHeight: pxToRem(42),
    padding: `${pxToRem(10)}`,
    borderBottom: `1px solid ${theme.palette.neutralLight}`,
    display: 'flex',
    selectors: {
      '&:hover': { background: 'none' },
    },
  },
  actionMessage: {
    fontWeight: 400,
  },
  activityContent: {
    background: 'transparent',
    boxShadow: 'none',
  },
  activityShowing: {
    fontWeight: 400,
    fontSize: pxToRem(12),
    color: theme.palette.neutralSecondary,
    selectors: {
      '& span': {
        fontWeight: 600,
      },
    },
  },
  activityLogHeader: {
    marginTop: '40px',
    borderBottom: `${pxToRem(1)} solid ${theme.palette.neutralLight}`,
  },
  bold: {
    fontWeight: 'bold',
  },
  date: {
    marginLeft: pxToRem(10),
    color: theme.palette.neutralSecondary,
    flexShrink: 0,
    marginTop: pxToRem(3),
  },
  details: {
    margin: 0,
    padding: 0,
    selectors: {
      li: {
        color: theme.palette.neutralDark,
        display: 'list-item',
        fontSize: pxToRem(12),
        listStyle: 'inside',
        position: 'relative',
      },
    },
  },
  itemContent: {
    overflow: 'hidden',
    flexGrow: 1,
  },
  itemIndex: {
    color: theme.palette.neutralDark,
    fontWeight: 600,
  },
  itemName: {
    marginTop: pxToRem(10),
    whiteSpace: 'normal',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    verticalAlign: 'baseline',
  },
  personaCoin: {
    flexShrink: pxToRem(0),
    borderRadius: pxToRem(15),
    padding: `${pxToRem(3)} ${pxToRem(12)} ${pxToRem(0)} ${pxToRem(12)}`,
    marginTop: pxToRem(-3),
    marginRight: pxToRem(7),
  },
  showMoreActivity: {
    fontSize: pxToRem(14),
    cursor: 'pointer',
    marginTop: pxToRem(14),
    color: theme.palette.themePrimary,
  },
  showMoreActivityButton: {
    float: 'right',
    selectors: {
      '&:hover': {
        color: theme.palette.themePrimary,
        textDecoration: 'none',
      },
    },
  },
});
